import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiMangaGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-manga-generator',
			name: 'AI Manga Generator — Online Manga Creator | Lift',
			description:
				"Create stunning AI generated manga art from your photos instantly with Lift's AI manga maker. Perfect for social media, and creative projects. No watermark.",
			url: 'https://liftapp.ai/ai-manga-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-manga-generator#product' },
				{ '@id': 'https://liftapp.ai/ai-manga-generator#howto' },
				{ '@id': 'https://liftapp.ai/ai-manga-generator#benefits' },
				{ '@id': 'https://liftapp.ai/ai-manga-generator#faq' },
				{ '@id': 'https://liftapp.ai/ai-manga-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-manga-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-manga-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-manga-generator#product',
			name: 'AI Manga Generator Online',
			description:
				"Bring your dream stories to life with Lift's advanced AI tools. Craft engaging tales in just a few clicks and share them with the world — no drawing skills required.",
			url: 'https://liftapp.ai/ai-manga-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-manga-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Apply manga transformation',
					text: 'Our AI converts your photo into authentic manga style',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-manga-generator#benefits',
			name: 'Who can benefit from AI Manga Generator?',
			description:
				"Lift's AI Manga Generator is useful for manga fans, comic creators, anime enthusiasts, aspiring manga artists, content creators, and social media users.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for manga fans, comic creators, and anime enthusiasts',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Aspiring manga artists can visualize character designs without manual illustration',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators can generate scroll-stopping visuals with authentic manga aesthetics',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Social media users can transform selfies into shareable manga-style portraits',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Quick, creative, and premium-quality — ideal for personal fun',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Manga Creator',
				description: 'AI Manga Creator',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-manga-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Manga Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Manga Generator is an online tool that transforms your photos into authentic manga-style artwork — complete with bold ink lines, dramatic shading, and expressive character details. Perfect for social media, comic projects, prints, or creative storytelling.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Manga Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo and applies signature manga aesthetics: high-contrast black-and-white rendering, clean linework, speed lines, and expressive features. The transformation happens automatically — no manual drawing or editing skills needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I create manga art from any type of photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift works with portraits, full-body shots, group photos, and even pets. The AI adapts to your image content and applies manga-style effects — from character close-ups to dramatic action scenes — while preserving your original composition.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, comics, or portfolio use.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-manga-generator#why-lift',
			name: "Why Lift's AI Manga Generator stands out",
			description:
				"Lift's AI Manga Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'AI Manga Filter',
				description: 'AI Manga Filter',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-manga-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-manga-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Manga Generator',
					item: 'https://liftapp.ai/ai-manga-generator',
				},
			],
		},
	],
};
